import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo-uniandes.png';


const Header = () =>{
    return(
        <header className="py-2 bg-slate-900">
            <section className="max-w-7xl mx-auto flex justify-start">
                <Link to="/">
                    <img
                        className="w-80 lg:w-96 h-auto"
                        src={logo}
                        alt="Logo Universidad de los Andes"
                    />
                </Link>
            </section>
        </header>
        
    )
}

export default Header;